import { render, staticRenderFns } from "./LoadMore.vue?vue&type=template&id=413b9c4c"
import script from "./LoadMore.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./LoadMore.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports